import axios from "axios";
import { useApi } from "../hooks/useApi";

const api = useApi();

export async function askCemadeIA(question: string): Promise<string> {
  try {
    const response = await api.post(`openai/assistant-cemade-ai`, { question });

    return response.data.reply;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response.status) {
          case 429: return "L’assistant Cemade reçoit trop de demandes actuellement. Réessaie plus tard 🙏";

          case 404: return 'Une erreur est survenue avec l’assistant IA. Réessaie plus tard.'
        }
      } else if (error.request) {
        return "Le serveur est injoignable pour le moment. Vérifie ta connexion ou réessaie plus tard.";
      }
      else {
        return "Une erreur inconnue est survenue. Essaie de reformuler ta question 🙏";
      }
    }
    // Cas générique, si ce n’est pas une erreur Axios
    return "Une erreur est survenue avec l’assistant IA. Réessaie dans un instant. 🙏";
  }
}